import { useQuery, UseQueryOptions } from 'react-query'

import { CareProviderIrisResponse } from '@providers/providers.types'
import { getCareProviders } from '@providers/providers.services'

export const useCareProvider = (customDomain?: string, options?: UseQueryOptions<CareProviderIrisResponse>) => {
  const defaultDomain = typeof window !== 'undefined' ? window.location.host : ''
  const domain = customDomain || defaultDomain

  const queryKey = `careProviders/${domain}`
  const queryFunc = () => getCareProviders({ domain })
  const queryOptions = { enabled: !!domain, retry: 2, staleTime: Infinity, ...options }

  const { data, ...rest } = useQuery<CareProviderIrisResponse>(queryKey, queryFunc, queryOptions)

  return { careProvider: data?.results?.[0], queryKey, ...rest }
}
